import { useNavigate } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../../assets/newIcons/arrow-back.svg";
import Step1 from "./info/step-1";
import { useParams } from "react-router-dom";

const PersonalInfo = ({
  userDetail,
  edit,
  firstText,
  secondText,
  control = false,
  setFormData,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div
      className="d-flex w-100 align-items-center justify-content-between"
      style={{ height: "10%" }}
    >
      <div className="d-flex align-items-center">
        <button
          onClick={() => {
            navigate(-1);
            localStorage.setItem("GraphicElevvaUserId", id);
          }}
          className={"button_w_h_back cursor-pointer"}
          style={{ background: "transparent", border: "none" }}
        >
          <BackArrow width={"100%"} height={"100%"} />
        </button>
        {control ? (
          <div>
            <span style={{ color: "var(--elevvabutonLogin_User)" }}>
              {firstText} <strong>{secondText}</strong>
            </span>{" "}
          </div>
        ) : (
          <div>
            {edit ? (
              <span style={{ color: "var(--elevvabutonLogin_User)" }}>
                Valoración
              </span>
            ) : (
              <span style={{ color: "var(--elevvabutonLogin_User)" }}>
                {firstText} <strong>{secondText}</strong>
              </span>
            )}
          </div>
        )}
      </div>
      <div>
        <Step1
          userDetail={userDetail}
          edit={edit}
          setFormData={setFormData}
          control={control}
        />
      </div>
    </div>
  );
};
export default PersonalInfo;
